<template>

<div id="metro-destinations">
    <h4 v-if="list"><b-icon icon="arrow-left-right"></b-icon><span>Vakiomääränpäät</span></h4>
    <h4 v-if="create"><b-icon icon="pencil-square"></b-icon><span >Lisää vakiomääränpää</span><b-icon icon="x-lg" class='close-btn' @click="showDestinationRuleList"></b-icon></h4>
    <h4 v-if="update"><b-icon icon="pencil-square"></b-icon><span >Muokkaa vakiomääränpäätä</span><b-icon icon="x-lg" class='close-btn' @click="showDestinationRuleList"></b-icon></h4>


    <transition name="fade" mode="out-in">
    
    <div v-if="list" key="list">
        <div>
            <div v-for="rule in destinationRules" :key="rule.station" class='destination-rule' @click="updateDestinationRule(rule.id)">
                <!--div class='validity'>
                    <b-icon icon="check-square-fill" class='valid' title="Voimassa"></b-icon>
                </div-->
                <div class='station'>
                    <div class='name'>{{ rule.station }}</div>
                    <div class='platforms'>
                        <div class='platform'>1</div>
                        <div class='platform'>2</div>
                    </div>
                    
                    <!--div> Laituri {{ rule.platform }} </div-->
                </div>
                <div class='original-destination'>
                    <div class='fi'> {{ rule.original.fi }} </div>
                    <div> {{ rule.original.se }} </div>
                </div>
                <div class='arrow'>
                    <b-icon icon="arrow-left-right"></b-icon>
                </div>
                <div class='new-destination'>
                    <div class='fi'> {{ rule.new.fi }} </div>
                    <div> {{ rule.new.se }} </div>
                </div>
                <div class='actions'>
                    <!--b-icon icon="pencil-square" title='Muokkaa' @click="updateDestinationRule(rule.id)"></b-icon-->
                    <b-icon icon="x-square" class='remove' title='Poista' @click.stop="deleteDestinationRule(rule.id)"></b-icon>
                </div>
            </div>
        </div>

        <div>
            <!--a href="#" class='link'><b-icon icon="chevron-down"></b-icon>Näytä aiemmat</a-->
            <t-button type="add" @click="createDestinationRule" style='float:right'>Lisää uusi</t-button>       
        </div>
    </div>

    <div v-if="create" key="create">
        <DestinationEditor type="create" :stations="stations" @close="showDestinationRuleList"></DestinationEditor>
    </div>

    <div v-if="update" key="update">
        <DestinationEditor type="update" :stations="stations" @close="showDestinationRuleList"></DestinationEditor>           
    </div>


    </transition>


     <DeleteModal itemid="" @ok="onDeleteOK" />

</div>

</template>


<script>

import DestinationEditor from "./DestinationEditor.vue";

export default {
    props: ['stations'],
    components: {
        DestinationEditor
    }, 
    data: function() {
        return  {
            destinationRules: [
              { id: 1, station: "Kivenlahti", platform: "1", original: { fi: "Vuosaari", se: "Nordsjö" }, new: { fi: "Matinkylä", se: "Mattby" } },
              { id: 2, station: "Espoonlahti", platform: "1", original: { fi: "Vuosaari", se: "Nordsjö" }, new: { fi: "Matinkylä", se: "Mattby" } },
              { id: 3, station: "Soukka", platform: "1", original: { fi: "Vuosaari", se: "Nordsjö" }, new: { fi: "Matinkylä", se: "Mattby" } },
              { id: 4, station: "Kaitaa", platform: "1", original: { fi: "Vuosaari", se: "Nordsjö" }, new: { fi: "Matinkylä", se: "Mattby" } },
              { id: 5, station: "Finnoo", platform: "1", original: { fi: "Vuosaari", se: "Nordsjö" }, new: { fi: "Matinkylä", se: "Mattby" } },

            ],
            list: true,
            create: false,
            update: false,
            deleteItemId: null
        }
    },
    methods: {
        showDestinationRuleList(){
            this.list = true;
            this.create = this.update = false;
            this.$emit('listMode');
        },
        createDestinationRule(){
            this.create = true;
            this.list = this.update = false ;
            this.$emit('editorMode');
        },
        updateDestinationRule(){
            this.update = true;
            this.list = this.create = false ;
            this.$emit('editorMode');
        },
        deleteDestinationRule(id){
            this.deleteItemId = id;
            this.$bvModal.show('delete-modal')

           
        },
        onDeleteOK() {
            if(this.deleteItemId)
                this.destinationRules = this.destinationRules.filter(rule => rule.id != this.deleteItemId);
        }

    }
}
</script>
